import { IconButton } from '@creditornot/cb-button';
import { FormRow, FormRowProps } from '@creditornot/cb-form';
import { DocumentEdit, Lock } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { PreviewRowContainer } from './OfferDetailsFormFields.styles';

const StyledPreviewRowContainer = styled(PreviewRowContainer)`
  gap: 8px;
  svg {
    flex-shrink: 0;
  }
`;

const PreviewFormRowRoot = styled(FormRow)``;
type PreviewFormRowProps = FormRowProps;
export const Preview = ({ children, ...formRowProps }: PreviewFormRowProps) => {
  return (
    <PreviewFormRowRoot {...formRowProps}>
      <PreviewRowContainer>{children}</PreviewRowContainer>
    </PreviewFormRowRoot>
  );
};

const LockedFormRowRoot = styled(FormRow)`
  color: ${cbSemanticCssVars.textSecondary};
  fill: ${cbSemanticCssVars.textSecondary};
`;
type LockedFormRowProps = FormRowProps;
export const Locked = ({ children, ...formRowProps }: LockedFormRowProps) => {
  return (
    <LockedFormRowRoot {...formRowProps}>
      <StyledPreviewRowContainer>
        {children}
        <Lock height="14" />
      </StyledPreviewRowContainer>
    </LockedFormRowRoot>
  );
};

const OverriddenFormRowRoot = styled(FormRow)``;
type OverriddenFormRowProps = FormRowProps;
export const Overridden = ({ children, ...formRowProps }: OverriddenFormRowProps) => {
  return (
    <OverriddenFormRowRoot {...formRowProps}>
      <StyledPreviewRowContainer>
        {children}
        {/* TODO: add tooltip with message */}
        <IconButton size="small" variant="neutral">
          {/* TODO: make icon button yellow */}
          <DocumentEdit />
        </IconButton>
      </StyledPreviewRowContainer>
    </OverriddenFormRowRoot>
  );
};

export const FormRows = {
  Preview,
  Locked,
  Overridden,
};
